import React from "react";

const LoadingSpinner = () => {
  return (
    <div className="svg-spinner-container">
      <svg
        className="svg-spinner"
        width="48"
        height="48"
        viewBox="0 0 50 50"
      >
        <circle
          className="svg-spinner-circle"
          cx="25"
          cy="25"
          r="20"
          fill="none"
          strokeWidth="5"
        />
      </svg>
    </div>
  );
};

export default LoadingSpinner;
